import { render, staticRenderFns } from "./DateTypeSelect.vue?vue&type=template&id=23eddf22&scoped=true"
import script from "./DateTypeSelect.vue?vue&type=script&lang=js"
export * from "./DateTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eddf22",
  null
  
)

export default component.exports